<ng-container *ngIf="fgInfo && fgInfo.type">
  <ng-container [ngSwitch]="fgInfo.type">
    <ng-container *ngSwitchCase="textType">
      @if(!isTime) {
        <ng-container>
          <app-ssn-input
            *ngIf="fgInfo.mask == '000-00-0000'"
            [readonly]="readonly"
            [controlName]="controlName"
            [data-automation-id]="dataAutomationId"
            [labelOverride]="labelOverride"
            [hint]="hint"
            [disabled]="disabled"
            [tooltipText]="tooltipText"
            [formInfo]="formInfo"
            [form]="formGroupOverride"
            [employeeId]="employeeId"
            [showViewSSNButton]="showViewSSNButton"
            [hasSSN]="hasSSN"
            [fieldDescription]="fieldDescription"
            [hideLabel]="hideLabel"
            (change)="onChanged($event)"
          ></app-ssn-input>
          <app-text-input
            *ngIf="fgInfo.mask != '000-00-0000'"
            [readonly]="readonly"
            [controlName]="controlName"
            [data-automation-id]="dataAutomationId"
            [labelOverride]="labelOverride"
            [hint]="hint"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [tooltipText]="tooltipText"
            [formInfo]="formInfo"
            [form]="formGroupOverride"
            [fieldDescription]="fieldDescription"
            [hideLabel]="hideLabel"
            [showCharacterCount]="showCharacterCount"
            (change)="onChanged($event)"
          ></app-text-input>
        </ng-container>
      } @else if (isTime) {
        <app-time-input
          [readonly]="readonly"
          [controlName]="controlName"
          [data-automation-id]="dataAutomationId"
          [labelOverride]="labelOverride"
          [hint]="hint"
          [disabled]="disabled"
          [fieldDescription]="fieldDescription"
          [hideLabel]="hideLabel"
          (change)="onChanged($event)"
        ></app-time-input>
      }
    </ng-container>
    <app-select-input
      *ngSwitchCase="selectType"
      [readonly]="readonly"
      [controlName]="controlName"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
      [data-automation-id]="dataAutomationId"
    ></app-select-input>
    <app-checkbox-input
      *ngSwitchCase="checkboxType"
      [readonly]="readonly"
      [controlName]="controlName"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-checkbox-input>
    <app-date-input
      *ngSwitchCase="dateType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-date-input>
    <app-number-input
      *ngSwitchCase="numberType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-number-input>
    <app-currency-input
      *ngSwitchCase="currencyType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-currency-input>
    <app-text-area-input
      *ngSwitchCase="textAreaType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-text-area-input>
    <app-email-input
      *ngSwitchCase="emailType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-email-input>
    <app-password-input
      *ngSwitchCase="passwordType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-password-input>
    <app-toggle-input
      *ngSwitchCase="toggleType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-toggle-input>
    <app-radio-input
      *ngSwitchCase="radioType"
      [readonly]="readonly"
      [controlName]="controlName"
      [data-automation-id]="dataAutomationId"
      [labelOverride]="labelOverride"
      [hint]="hint"
      [disabled]="disabled"
      [tooltipText]="tooltipText"
      [formInfo]="formInfo"
      [form]="formGroupOverride"
      [fieldDescription]="fieldDescription"
      [hideLabel]="hideLabel"
      (change)="onChanged($event)"
    ></app-radio-input>
    <span *ngSwitchDefault>Type not supported</span>
  </ng-container>
</ng-container>
